export class Costcenters {
    id: string;
    name: string;
  master_costcenter_id: string;

  sub_costcenter_expected: string;
  Classification_costcenter: string;
  costcenter_nature: string;
  final_costcenter: string;
  max_credit: string;
  max_debit: string;

    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;

  showDeletedOnly: boolean;

    constructor( ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/costcenters/costcenters.ts